module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-bright-red-down.dc8c8d9b.svg";